<template>
  <v-card class="mx-4 my-6" :style="cardClass" id="ra-card">
    <v-text-field
      :label="label"
      dense
      hide-details
      filled
      disabled
      required
      v-model="value"
      class="px-4 py-4"
      id="ra-input"
    ></v-text-field>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import ReconciliationDetailData from '@/mixins/ReconciliationDetailData';
import { MobileView } from '@/mixins';
import card from '@/mixins/card';

export default {
  mixins: [ReconciliationDetailData, MobileView, card],
  computed: {
    ...mapGetters({
      _client: 'account/getCurrentClient',
    }),
    cardClass() {
      if (this.showMobileView) {
        return 'overflow:hidden;';
      }
      return 'width:50%; overflow:hidden;';
    },
    label() {
      if (this._client.client_name === 'shark') {
        return 'UUID';
      }
      return 'RA #';
    },
    value() {
      if (this._client.client_name === 'shark') {
        return this.details.uuid;
      }
      return this.details.ra_number;
    },
  },
};
</script>

<style></style>
